import { render, staticRenderFns } from "./lesson-calendar.vue?vue&type=template&id=3ec8c674&scoped=true"
import script from "./lesson-calendar.vue?vue&type=script&lang=js"
export * from "./lesson-calendar.vue?vue&type=script&lang=js"
import style0 from "./lesson-calendar.vue?vue&type=style&index=0&id=3ec8c674&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec8c674",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ec8c674')) {
      api.createRecord('3ec8c674', component.options)
    } else {
      api.reload('3ec8c674', component.options)
    }
    module.hot.accept("./lesson-calendar.vue?vue&type=template&id=3ec8c674&scoped=true", function () {
      api.rerender('3ec8c674', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/senate/lesson-calendar.vue"
export default component.exports